<div class="container-fluid">
  <div class="row">
    <!-- <div
      class="col-xl-7 rounded-end-5"
      [ngStyle]="{
        'background-image': 'url(assets/images/login/login_splash.jpg)',
        'background-size': 'cover',
        'background-position': 'center center',
        display: 'block'
      }"
    >
      <img
        class="bg-img-cover bg-center d-none"
        src="assets/images/login/login_splash.jpg"
        alt="looginpage"
      />
    </div> -->
    <div class="col-xl-5 p-0" style="width: 100%;">
      <div class="login-card login-dark">
        <div>
          <div class="logo text-center">
            <img
              class="img-fluid for-light"
              src="assets/images/logo/logo.png"
              alt="looginpage"
              width="300"
            />
            <img
              class="img-fluid for-dark"
              src="assets/images/logo/logo_dark.png"
              alt="looginpage"
            />
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="form">
              <h4 class="innoku-color">{{ "SignUp.Title" | translate }}</h4>
              <div class="form-group">
                <label class="col-form-label">{{
                  "SignUp.Fileds.Name" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.name.touched
                      ? ''
                      : !form.controls.name?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  type="text"
                  formControlName="name"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">{{
                  "SignUp.Fileds.Email" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.email.touched
                      ? ''
                      : !form.controls.email?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  type="email"
                  formControlName="email"
                />
              </div>
              <div class="form-group">
                <label class="col-form-label">{{
                  "SignUp.Fileds.Password" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.password.touched
                      ? ''
                      : !form.controls.password?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  [type]="showPassword ? 'text' : 'password'"
                  formControlName="password"
                  placeholder="*********"
                  (keydown.enter)="signUp()"
                />
                <div
                  class="show-hide"
                  (click)="toggleShowPassword()"
                  *ngIf="!showPassword"
                >
                  <span class="show"></span>
                </div>
                <div
                  class="show-hide"
                  (click)="toggleShowPassword()"
                  *ngIf="showPassword"
                >
                  <span class="Hide"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">{{
                  "SignUp.Fileds.ConfirmPassword" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.confirmPassword.touched
                      ? ''
                      : !form.controls.confirmPassword?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  [type]="showConfirmPassword ? 'text' : 'password'"
                  formControlName="confirmPassword"
                  placeholder="*********"
                  (keydown.enter)="signUp()"
                />
                <div
                  class="show-hide"
                  (click)="toggleShowConfirmPassword()"
                  *ngIf="!showConfirmPassword"
                >
                  <span class="show"></span>
                </div>
                <div
                  class="show-hide"
                  (click)="toggleShowConfirmPassword()"
                  *ngIf="showConfirmPassword"
                >
                  <span class="Hide"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="col-form-label">{{
                  "SignUp.Fileds.RememberPhrase" | translate
                }}</label>
                <input
                  [ngClass]="[
                    'form-control',
                    !form.controls.rememberPhrase.touched
                      ? ''
                      : !form.controls.rememberPhrase?.errors
                      ? 'is-valid'
                      : 'is-invalid'
                  ]"
                  type="text"
                  formControlName="rememberPhrase"
                />
              </div>
              <div class="form-group mb-0">
                <div class="text-end mt-3">
                  <button
                    class="btn btn-primary-innoku d-block w-100"
                    [disabled]="!form.valid"
                    (click)="signUp()"
                    type="button"
                  >
                    <span
                      >{{ "SignUp.BtnSubmitLabel" | translate }}
                      <span
                        class="spinner-border spinner-border-sm"
                        *ngIf="loading"
                      ></span
                    ></span>
                  </button>
                </div>
              </div>
              <p class="mt-4 mb-0">
                {{ "SignUp.GoBackQuestion" | translate }}
                <a [routerLink]="'/auth/login'" class="ms-2 innoku-color">{{
                  "SignUp.GoBackLink" | translate
                }}</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
